<div class="sale-regular-price" [innerHTML]="displayPriceRegular() | currencyHtml"></div>
<div class="price" [innerHTML]="displayPrice() | currencyHtml"></div>
<ideal-call-for-price-button class="call-for-price" />
<div class="price-unit">
  @let quantity = displayQuantity();
  @let perContainer = displayContainerQuantity();
  @switch (viewState()) {
    @case ("container") {
      @if (multiplyBy() === 1) {
        <!-- prettier-ignore -->
        <div per class="indent" i18n="@@product.box-of.label">
    {{ quantity | i18nPlural: displayContainerUnitLabel() }} of {perContainer, plural,
    =1 { {{ perContainer | i18nPlural: displayUnitLabel() }}}
    other { {{ perContainer | number }} {{ perContainer | i18nPlural: displayUnitLabel() }}}
    }
  </div>
      } @else {
        <!-- prettier-ignore -->
        <div i18n="@@product.boxes-of.label">
    {quantity, plural,
    =1 { {{ quantity | i18nPlural: displayContainerUnitLabel() }}}
    other { {{ quantity | number }} {{ quantity | i18nPlural: displayContainerUnitLabel() }}}
    }
    of {perContainer, plural,
    =1 { {{ perContainer | i18nPlural: displayUnitLabel() }}}
    other { {{ perContainer | number }} {{ perContainer | i18nPlural: displayUnitLabel() }}}
    }
  </div>
      }
    }
    @default {
      <!-- prettier-ignore -->
      <div i18n="@@product.units.label">
    {quantity, plural,
    =1 { {{ quantity | i18nPlural: displayUnitLabel() }}}
    other { {{ quantity | number }} {{ quantity | i18nPlural: displayUnitLabel() }}}
    }
  </div>
    }
  }
  <!-- <pre>{{ displayUnitLabel() | json }}</pre> -->
</div>
<div class="notice">
  <!-- @let priceData = sale(); -->

  <ideal-item-price-sale-and-fees-info-button-view [pricing]="pricing()" [multiplyBy]="multiplyBy()" />

  <!-- <button mat-button [matMenuTriggerFor]="saleInfo">
    <span>{{ notice() }}</span>
  </button>
  <mat-menu #saleInfo="matMenu">
    <div sales-info-popup>
      @switch (priceData?.type) {
        @case ("promotion") {
          <div class="promotion">
            <div class="title">
              <span>{{ priceData!.promotionName }}</span>
            </div>
            <div class="starts">
              <span class="label">Starts</span><span>{{ priceData!.effectiveDate | date }}</span>
            </div>
            <div class="ends">
              <span class="label">Ends</span><span>{{ priceData!.expiryDate | date }}</span>
            </div>
          </div>
        }
        @case ("quote") {
          <div class="quote">
            <div class="title">
              <span class="label">Quote #</span><span>{{ priceData!.quoteNumber }}</span>
            </div>
            <div class="line">
              <span class="label">Line #</span><span>{{ priceData!.quoteLine }}</span>
            </div>
            <div class="starts">
              <span class="label">Starts</span><span>{{ priceData!.effectiveDate | date }}</span>
            </div>
            <div class="ends">
              <span class="label">Ends</span><span>{{ priceData!.expiryDate | date }}</span>
            </div>
          </div>
        }
      }
    </div>
    @switch (priceData?.type) {
      @case ("promotion") {
        <a mat-menu-item [routerLink]="['/promotions', priceData!.promotionId]"><div class="label">View Promotion</div></a>
      }
      @case ("quote") {
        <a mat-menu-item [routerLink]="['/quotes', priceData!.quoteId]"><div class="label">View Quote</div></a>
      }
    }
  </mat-menu> -->
</div>

<!-- <div class="sale-limited-notice">
  <button mat-button [matMenuTriggerFor]="saleInfo"><span>Limited Time</span></button>

</div> -->
